var _g, _g2, _path, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMallMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1989_9803)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5183,
    cy: 39.5781,
    rx: 5.1726,
    ry: 1.84736,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_9803)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5178 3C28.0881 3 35.0356 9.94756 35.0356 18.5178C35.0356 25.0889 30.9513 30.7061 25.1828 32.9691L20.4017 39.5043C20.302 39.6411 20.1696 39.7528 20.0158 39.8298C19.862 39.9069 19.6912 39.9472 19.5178 39.9472C19.3445 39.9472 19.1736 39.9069 19.0198 39.8298C18.866 39.7528 18.7336 39.6411 18.634 39.5043L13.8528 32.9691C8.08433 30.7061 4 25.0889 4 18.5178C4 9.94756 10.9476 3 19.5178 3Z",
    fill: "#00A997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1241 18.562C32.1241 11.6242 26.4999 6 19.562 6C12.6242 6 7 11.6242 7 18.562C7 25.4999 12.6242 31.1241 19.562 31.1241C26.4999 31.1241 32.1241 25.4999 32.1241 18.562Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_9803)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1989_9803)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1989_9803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 11.4902C15.5195 10.6634 16.1869 9.99609 17.0137 9.99609C17.8405 9.99609 18.5078 10.6634 18.5078 11.4902V13.0176H19.5039V11.4902C19.5039 10.1156 18.3883 9 17.0137 9C15.6391 9 14.5234 10.1156 14.5234 11.4902V13.0176H15.5195V11.4902Z",
    fill: "#AB47BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0098 17.002H21.9941V13.0176H19.5039V15.0098H18.5078V13.0176H15.5195V15.0098H14.5234V13.0176H12V26H18.0098V17.002Z",
    fill: "#AB47BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 26H29V17.998H19.0059V26ZM21.4961 19.4922H22.4922V19.9902C22.4922 20.8141 23.1624 21.4844 23.9863 21.4844C24.8102 21.4844 25.4805 20.8141 25.4805 19.9902V19.4922H26.4766V19.9902C26.4766 21.3633 25.3594 22.4805 23.9863 22.4805C22.6133 22.4805 21.4961 21.3633 21.4961 19.9902V19.4922Z",
    fill: "#AB47BC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_9803",
    x: 12.8678,
    y: 36.2528,
    width: 13.3005,
    height: 6.65064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.738955,
    result: "effect1_foregroundBlur_1989_9803"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_9803",
    x: 0.305226,
    y: 0.0441809,
    width: 38.4247,
    height: 44.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.738955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_9803"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_9803",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_9803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1989_9803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(12 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1989_9803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(12 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMallMapIcon);
export default __webpack_public_path__ + "static/media/mallMapIcon.e8f558dfa814c79263b5759136e1d036.svg";
export { ForwardRef as ReactComponent };